import React, { memo, useMemo } from 'react';

import { Avatar, AvatarProps } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { environmentConfig } from '../../configs/EnvironmentConfig';
import { vimeoConfig } from '../../configs/VimeoConfig';

interface ICdnAvatarProps extends IBaseDomElementProps {
  size?: AvatarProps['size'];
  src: string;
  fallback?: string;
}

/**
 * Safely display avatar if URL is based on current env CDN.
 * Do not allow placing links from external resources.
 */
export const CdnAvatar = memo(
  ({
    id,
    className,
    size = 'md',
    src,
    fallback = vimeoConfig.USER.DEFAULT_LOGO_URL(75),
  }: ICdnAvatarProps) => {
    const avatarSrc = useMemo(() => {
      const cdnUrl: string = environmentConfig.IS_DEV ? vimeoConfig.CDN.DEV : vimeoConfig.CDN.PROD;

      if (String(src).startsWith(cdnUrl)) {
        return src;
      } else {
        return fallback;
      }
    }, [src, fallback]);

    return <Avatar id={id} className={className} size={size} src={avatarSrc} alt={'avatar'} />;
  },
);
